import {
  ItemAlreadyExistsError,
  ItemNotFoundError,
  CollectionAlreadyExistsError,
  CollectionNotFoundError,
  ReferenceAlreadyExistsError,
  ReferenceNotFoundError,
  ValidationError,
  CollectionChangeNotSupported,
} from './service-plugins-types.js';

/**
 * There is already an item with this ID.
 */
export class ItemAlreadyExistsWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorSchemaName: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  data: ItemAlreadyExistsError;

  constructor(data: ItemAlreadyExistsError = {}) {
    super('ItemAlreadyExists');

    this.httpCode = 409;
    this.statusCode = 'ALREADY_EXISTS';
    this.applicationCode = 'ITEM_ALREADY_EXISTS';
    this.name = 'ItemAlreadyExists';
    this.errorSchemaName =
      'com.wixpress.cloud.externaldatabasespi.v3.ItemAlreadyExistsError';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'ItemAlreadyExists',
      applicationCode: 'ITEM_ALREADY_EXISTS',
    };

    this.data = data;
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * Couldn't find the item.
 */
export class ItemNotFoundWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorSchemaName: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  data: ItemNotFoundError;

  constructor(data: ItemNotFoundError = {}) {
    super('ItemNotFound');

    this.httpCode = 404;
    this.statusCode = 'NOT_FOUND';
    this.applicationCode = 'ITEM_NOT_FOUND';
    this.name = 'ItemNotFound';
    this.errorSchemaName =
      'com.wixpress.cloud.externaldatabasespi.v3.ItemNotFoundError';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'ItemNotFound',
      applicationCode: 'ITEM_NOT_FOUND',
    };

    this.data = data;
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * There is already a collection with this ID.
 */
export class CollectionAlreadyExistsWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorSchemaName: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  data: CollectionAlreadyExistsError;

  constructor(data: CollectionAlreadyExistsError = {}) {
    super('CollectionAlreadyExists');

    this.httpCode = 409;
    this.statusCode = 'ALREADY_EXISTS';
    this.applicationCode = 'COLLECTION_ALREADY_EXISTS';
    this.name = 'CollectionAlreadyExists';
    this.errorSchemaName =
      'com.wixpress.cloud.externaldatabasespi.v3.CollectionAlreadyExistsError';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'CollectionAlreadyExists',
      applicationCode: 'COLLECTION_ALREADY_EXISTS',
    };

    this.data = data;
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * Couldn't find the collection.
 */
export class CollectionNotFoundWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorSchemaName: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  data: CollectionNotFoundError;

  constructor(data: CollectionNotFoundError = {}) {
    super('CollectionNotFound');

    this.httpCode = 404;
    this.statusCode = 'NOT_FOUND';
    this.applicationCode = 'COLLECTION_NOT_FOUND';
    this.name = 'CollectionNotFound';
    this.errorSchemaName =
      'com.wixpress.cloud.externaldatabasespi.v3.CollectionNotFoundError';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'CollectionNotFound',
      applicationCode: 'COLLECTION_NOT_FOUND',
    };

    this.data = data;
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * There is already a reference between these items.
 */
export class ReferenceAlreadyExistsWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorSchemaName: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  data: ReferenceAlreadyExistsError;

  constructor(data: ReferenceAlreadyExistsError = {}) {
    super('ReferenceAlreadyExists');

    this.httpCode = 409;
    this.statusCode = 'ALREADY_EXISTS';
    this.applicationCode = 'REFERENCE_ALREADY_EXISTS';
    this.name = 'ReferenceAlreadyExists';
    this.errorSchemaName =
      'com.wixpress.cloud.externaldatabasespi.v3.ReferenceAlreadyExistsError';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'ReferenceAlreadyExists',
      applicationCode: 'REFERENCE_ALREADY_EXISTS',
    };

    this.data = data;
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * Couldn't find the reference.
 */
export class ReferenceNotFoundWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorSchemaName: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  data: ReferenceNotFoundError;

  constructor(data: ReferenceNotFoundError = {}) {
    super('ReferenceNotFound');

    this.httpCode = 404;
    this.statusCode = 'NOT_FOUND';
    this.applicationCode = 'REFERENCE_NOT_FOUND';
    this.name = 'ReferenceNotFound';
    this.errorSchemaName =
      'com.wixpress.cloud.externaldatabasespi.v3.ReferenceNotFoundError';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'ReferenceNotFound',
      applicationCode: 'REFERENCE_NOT_FOUND',
    };

    this.data = data;
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * 1 or more field values are invalid.
 */
export class ValidationWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorSchemaName: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  data: ValidationError;

  constructor(data: ValidationError = {}) {
    super('ValidationError');

    this.httpCode = 400;
    this.statusCode = 'INVALID_ARGUMENT';
    this.applicationCode = 'VALIDATION_ERROR';
    this.name = 'ValidationError';
    this.errorSchemaName =
      'com.wixpress.cloud.externaldatabasespi.v3.ValidationError';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'ValidationError',
      applicationCode: 'VALIDATION_ERROR',
    };

    this.data = data;
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * The collection field can't be changed.
 */
export class CollectionChangeNotSupportedWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorSchemaName: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  data: CollectionChangeNotSupported;

  constructor(data: CollectionChangeNotSupported = {}) {
    super('CollectionChangeNotSupportedError');

    this.httpCode = 400;
    this.statusCode = 'INVALID_ARGUMENT';
    this.applicationCode = 'COLLECTION_CHANGE_NOT_SUPPORTED';
    this.name = 'CollectionChangeNotSupportedError';
    this.errorSchemaName =
      'com.wixpress.cloud.externaldatabasespi.v3.CollectionChangeNotSupported';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'CollectionChangeNotSupportedError',
      applicationCode: 'COLLECTION_CHANGE_NOT_SUPPORTED',
    };

    this.data = data;
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}

/**
 * The request is invalid.
 */
export class BadRequestWixError extends Error {
  /** @hidden */
  httpCode: number;
  /** @hidden */
  statusCode: string;
  /** @hidden */
  applicationCode: string;
  /** @hidden */
  name: string;
  /** @hidden */
  errorType: string;
  /** @hidden */
  spiErrorData: object;

  constructor() {
    super('BadRequestError');

    this.httpCode = 400;
    this.statusCode = 'INVALID_ARGUMENT';
    this.applicationCode = 'BAD_REQUEST';
    this.name = 'BadRequestError';
    this.errorType = 'SPI';
    this.spiErrorData = {
      name: 'BadRequestError',
      applicationCode: 'BAD_REQUEST',
    };
  }

  /** @hidden */
  static readonly __type = 'wix_spi_error';
}
